export default class UserNotFoundError extends Error {
  email: string;

  constructor(email: string) {
    super(`No user found for email: ${email}`);

    this.email = email;
  }
}
